export const USER_ROLES = {
  PACIENTE: 'paciente',
  MEDICO: 'medico',
};
